import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        this.GetInfo();
        await this.GetAllAcademicLevels();
        await this.GetAllSubjects();
        await this.GetAllInstructors();
        await this.GetAllStudents();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: ' الإشعارات ',
            ScreenTitleSingle: ' إشعار ',
            ScreenTitleSingleAl: 'الإشعار',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem:'',

            ruleForm: {
                Id: '',
                Type: '',
                AcademicLevelsId: '',
                AcademicSpecializationId: '',
                SubjectId: '',
                TargetId: '',
                Title: '',
                Content: '',
            },
            rules: {
                Type: this.$helper.Required(),
                TargetId: this.$helper.Required(),
                Title: this.$helper.Required(),
                Content: this.$helper.Required(),
            },
        };
    },



    methods: {

        ClearTarget() {
            this.ruleForm.TargetId = '';
        },

        

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            if (this.Search === null) this.Search = '';

            this.$http.GetNotifications(this.pageNo, this.pageSize, this.Search.trim())
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    if (this.ruleForm.Type == 1)
                        this.ruleForm.TargetId = Number(0);
                    this.$blockUI.Start();
                    this.$http.PushNotifications(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },
    }
}
